import { Notifications } from '@features/profile/components/notifications/Notifications';
import * as React from 'react';

const NotificationsRoute = React.memo((): React.ReactElement => {
  return <Notifications />;
});

NotificationsRoute.displayName = 'NotificationsRoute';

export { NotificationsRoute };
